module.exports = __webpack_public_path__ + "media/images/flags/bi-4b8c26ac7a184ebdab3595f4978b6705.svg";